"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _dropdown = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/dropdown"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _MoreHoriz = _interopRequireDefault(require("@insided/shared/icons/MoreHoriz"));

var _SubtleButton = _interopRequireDefault(require("@insided/shared/uikit/SubtleButton"));

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ActionsMenu = function ActionsMenu(_ref) {
  var menuOptions = _ref.menuOptions,
      className = _ref.className;
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)("actions-menu ".concat(className !== null && className !== void 0 ? className : ''), 'text--meta', 'post__actions', 'qa-post-actions')
  }, (0, _preact.h)(_dropdown.default, {
    size: "S",
    align: "right",
    popupName: "topic-menu-actions",
    closeOnDropdownClick: true,
    className: "actions-menu-dropdown",
    trigger: function trigger(isTriggerOpen) {
      return (0, _preact.h)(_phrase.default, {
        p: "accessibility_label.show_additional_post_actions",
        renderAsText: true
      }, function (accessibilityLabel) {
        return (0, _preact.h)(_SubtleButton.default, {
          size: "medium",
          className: (0, _classnames.default)('more-actions-button', 'tooltip-trigger', 'js-tooltip-trigger'),
          icon: (0, _preact.h)(_MoreHoriz.default, {
            width: 16,
            height: 16
          }),
          "aria-label": accessibilityLabel,
          isSelected: isTriggerOpen
        });
      });
    }
  }, menuOptions === null || menuOptions === void 0 ? void 0 : menuOptions.map(function (item) {
    return (0, _preact.h)(_dropdown.DropdownItem, {
      key: item.title,
      type: item.type,
      onClick: item.onClick
    }, (0, _preact.h)(_phrase.default, {
      p: item.title
    }));
  })));
};

var _default = ActionsMenu;
exports.default = _default;